<template>
  <div>
    <b-table-simple
      borderless
      striped
      responsive="sm"
      class="mb-0"
    >
      <b-thead>
        <b-tr>
          <b-th
            class="text-center width-50"
          >
            <FeatherIcon icon="EyeIcon" />
          </b-th>
          <b-th>Tanım</b-th>
          <b-th class="width-200 text-right text-nowrap">
            Toplam Tutar
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="(item,index) in dataList">
          <b-tr :key="item.id">
            <b-td class="text-center">
              <b-button
                :variant="item.toggle? 'flat-danger' : 'flat-success'"
                pill
                class="btn-icon"
                @click="toggleDetail(index)"
              >
                <FeatherIcon :icon="item.toggle? 'EyeOffIcon' : 'EyeIcon'" />
              </b-button>
            </b-td>
            <b-td>
              {{ item.title }}
            </b-td>
            <b-td class="text-right text-nowrap font-weight-bold text-primary">
              {{ item.amount | toCurrency }} TL
            </b-td>
          </b-tr>
          <template
            v-for="subitem in item.items"
          >
            <b-tr
              v-if="item.toggle"
              :key="subitem.id"
              class="text-secondary"
            >
              <b-td />
              <b-td>
                {{ subitem.title }}
                <div class="font-small-2 text-warning">
                  {{ subitem.donation_type }}
                </div>
              </b-td>
              <b-td class="text-right text-nowrap font-weight-bold">
                {{ subitem.amount | toCurrency }} TL
              </b-td>
            </b-tr>
          </template>
        </template>
      </b-tbody>
      <b-tfoot>
        <b-tr>
          <b-th />
          <b-th>
            Genel Toplam
          </b-th>
          <b-th class="text-right text-nowrap">
            {{ grandTotal | toCurrency }} TL
          </b-th>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
  </div>
</template>
<script>
import {
  BTableSimple, BThead, BTbody, BTr, BTh, BTd, BTfoot, BButton,
} from 'bootstrap-vue'

export default {
  name: 'ReportTable',
  components: {
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BTfoot,
    BButton,
  },
  computed: {
    dataList() {
      return this.$store.getters['incomesReports/dataList']
    },
    grandTotal() {
      return this.$store.getters['incomesReports/grandTotal']
    },
  },
  methods: {
    toggleDetail(index) {
      this.dataList[index].toggle = !this.dataList[index].toggle
    },
  },
}
</script>
